// generalized substring match
export const filterMatch = (string, filter) => string.toLowerCase().includes(filter.toLowerCase());
